import {IReaderPublication} from "@colibrio/colibrio-reader-framework/colibrio-readingsystem-base";
import {IEpubReaderPublication} from "@colibrio/colibrio-reader-framework/colibrio-readingsystem-formatadapter-epub";
import {IPdfReaderPublication} from "@colibrio/colibrio-reader-framework/colibrio-readingsystem-formatadapter-pdf";
import {PublicationType} from "@colibrio/colibrio-reader-framework/colibrio-core-publication-base";
import {
    IWpAudiobookReaderPublication
} from "@colibrio/colibrio-reader-framework/colibrio-readingsystem-formatadapter-wp-audiobook";

export class VanillaReaderUtils {
    static isEpubReaderPublication(readerPublication: IReaderPublication): readerPublication is IEpubReaderPublication {
        return readerPublication.getSourcePublication().getType() === PublicationType.EPUB
    }

    static isPdfReaderPublication(readerPublication: IReaderPublication): readerPublication is IPdfReaderPublication {
        return readerPublication.getSourcePublication().getType() === PublicationType.PDF;
    }

    static isWpAudiobookReaderPublication(readerPublication: IReaderPublication): readerPublication is IWpAudiobookReaderPublication {
        return readerPublication.getSourcePublication().getType() === PublicationType.WP;
    }
}
